import React from "react";
import { Skeleton } from "src/@/components/ui/skeleton"; // ShadCN Skeleton component
import { Card, CardHeader, CardContent, CardFooter } from "src/@/components/ui/card";

const SkeletonAutomation = () => {
  return (
    <div className="flex flex-col lg:flex-row space-y-6 lg:space-y-0 lg:space-x-6 p-6 bg-gray-100">
      {/* Left Section */}
      <Card className="flex-1">
        <CardHeader>
          <Skeleton className="h-6 w-32" /> {/* Title */}
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div>
              <Skeleton className="h-4 w-20 mb-2" /> {/* Label */}
              <Skeleton className="h-10 w-full" /> {/* Select */}
            </div>
            <div>
              <Skeleton className="h-4 w-20 mb-2" /> {/* Label */}
              <Skeleton className="h-10 w-full" /> {/* Select */}
            </div>
            <div>
              <Skeleton className="h-4 w-32 mb-2" /> {/* Label */}
              <div className="flex space-x-2">
                <Skeleton className="h-8 w-24" /> {/* Badge */}
                <Skeleton className="h-8 w-24" /> {/* Badge */}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Right Section */}
      <Card className="flex-1">
        <CardHeader>
          <Skeleton className="h-6 w-32" /> {/* Title */}
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            {/* Action 1 */}
            <div className="space-y-4">
              <Skeleton className="h-4 w-48" /> {/* Subtitle */}
              <div>
                <Skeleton className="h-4 w-20 mb-2" /> {/* Label */}
                <Skeleton className="h-10 w-full" /> {/* Input */}
              </div>
            </div>

            {/* Action 2 */}
            <div className="space-y-4">
              <Skeleton className="h-4 w-48" /> {/* Subtitle */}
              <div>
                <Skeleton className="h-4 w-20 mb-2" /> {/* Label */}
                <Skeleton className="h-10 w-full" /> {/* Select */}
              </div>
              <div>
                <Skeleton className="h-4 w-20 mb-2" /> {/* Label */}
                <Skeleton className="h-10 w-full" /> {/* Select */}
              </div>
            </div>
          </div>
        </CardContent>
        <CardFooter>
          <Skeleton className="h-10 w-40" /> {/* Button */}
        </CardFooter>
      </Card>
    </div>
  );
};

export default SkeletonAutomation;
